import * as React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { IconButton } from '@mui/material';

export function FacebookIcon() {
  return (
      <img width="24px" height="24px" src="/svg/facebookIcon.svg"/>
  );
}
export function AzuerIcon() {
  return (
      <img src="/svg/azureIcon.svg"/>
  )
}
export function GoogleIcon() {
  return (
      <img src="/svg/googleIcon.svg"/>
  );
}